<div class="wrap" *ngIf="!showLogoutContainer">
  <div class="spin">
    <kendo-loader
      [type]="loader.type"
      [themeColor]="loader.themeColor"
      [size]="loader.size"
    >
    </kendo-loader>
  </div>
</div>

<div class="container" *ngIf="showLogoutContainer">
  <div class="content">
    <div class="center-column">
      <h2 style="text-align: center;">Something appears to have gone wrong.<br/>Please logout and log back in to retry.</h2>
      <div class="button-wrapper">
        <app-primary-button
          [text]="'Logout'"
          [clickEvent]="this.logout.bind(this)"
        ></app-primary-button>
      </div>
    </div>
  </div>
</div>